import React, { useEffect, useState } from "react";

const PartialPaymentPage = ({ fieldToShow = [], InvoiceData,summerizedInvoice,onComplete }) => {
  const paymentInformationBox = {
    backgroundColor: "white",
    borderRadius: "15px",
    width: "90%",
    paddingBottom: "20px",
    marginTop: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
  };

  const paymentInformationTitle = {
    color: "#192A3A",
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    margin: "10px 20px 5px 20px",
    fontWeight: "400",
    textAlign: "center",
  };
  const paymentInformationDetails = {
    color: "#192A3A",
    fontSize: "14px",
    margin: "5px 20px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "200",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const amountStyle = {
    fontWeight: "500",
    border: "none",
    maxWidth: "fit-content",
    textAlign: "right",
    borderBottom: "1px solid black",
    borderRadius: "0px",
    outline: "none",
  };
  const borderLines = {
    width: "90%",
    height: "1px",
    backgroundColor: "rgba(168, 180, 204, 0.5)",
    margin: "10px 20px",
  };
  const totalPayableAmount = {
    color: "#192A3A",
    fontSize: "25px",
    fontWeight: "600",
  };
  const continueButton = {
    marginTop: "20px",
    width: "90%",
    height: "40px",
    borderRadius: "10px",
    marginBottom: "20px",
    fontSize: "18px",
    color: "white",
    border: "none",
    backgroundColor: "#192A3A",
  };

  console.log("data",InvoiceData);
  const [invoiceDataEditable, setInvoiceData] = useState({ 
    details: {
      Rent: InvoiceData?.rent,
      Water: InvoiceData?.water,
      Arrears: InvoiceData?.arrears,
      ServiceFees: InvoiceData?.service_charge,
      Garbage: InvoiceData?.garbage,
      Total: InvoiceData?.Total,
      UnpaidDeposit: InvoiceData?.unpaid_deposit,
    },
   });
  useEffect(() => { 
    console.log(invoiceDataEditable);
  }, [invoiceDataEditable]);

  const calculateTotalAmount = () => {
    return Object.keys(invoiceDataEditable.details)
      .filter(key => key !== "Total")
      .reduce((sum, key) => sum + parseFloat(invoiceDataEditable.details[key] || 0), 0);
  };

  const handleInputFocus = (event) => {
    event.stopPropagation();
    // Delay to allow keyboard to appear
    setTimeout(() => {
      event.target.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 300);
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={paymentInformationBox}>
        <div style={paymentInformationTitle}>Edit Details Before Payment</div>
        {!fieldToShow.length && (
          <>
            {Object.keys(invoiceDataEditable.details).map((key) => (
              // if key is  Total skip it
              key === "Total" ? null : (
              <div style={paymentInformationDetails} key={key}>
                <div>{key}</div>
                <input
                  onFocus={handleInputFocus}
                  type="number"
                  style={amountStyle}
                  value={invoiceDataEditable.details[key]}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceDataEditable,
                      details: {
                        ...invoiceDataEditable.details,
                        [key]: e.target.value,
                      },
                    })
                  }
                />
              </div>
            )))}
            <div style={borderLines}></div>
          
            <div style={paymentInformationDetails}>
              Total Payable Amount
              <div style={totalPayableAmount}>
                ksh {calculateTotalAmount()}
              </div>
            </div>
          </>
        )}
        {fieldToShow[0] === "rent" && (
          <div style={paymentInformationDetails}>
            <div>Rent</div>
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.Rent}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    Rent: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
        {fieldToShow[0] === "water" && (
          <div style={paymentInformationDetails}>
            <div>Water</div>
            {/* <div style={amountStyle}>
               {invoiceDataEditable.details.Water}
            </div> */}
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.Water}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    Water: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
       {fieldToShow[0] === "arrears" && (
          <div style={paymentInformationDetails}>
            <div>Arrears</div>
            {/* <div style={amountStyle}>
              ksh {invoiceDataEditable.details.Arrears}
            </div> */}
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.Arrears}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    Arrears: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
        {fieldToShow[0] === "serviceCharge" && (
          <div style={paymentInformationDetails}>
            <div>Service Charge</div>
            {/* <div style={amountStyle}>
              ksh {invoiceDataEditable.details.Fees}
            </div> */}
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.ServiceFees}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    ServiceFees: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
          {fieldToShow[0] === "unpaidDeposit" && (
          <div style={paymentInformationDetails}>
            <div>Unpaid Deposit</div>
            {/* <div style={amountStyle}>
              ksh {invoiceDataEditable.details.Total}
            </div> */}
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.UnpaidDeposit}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    UnpaidDeposit: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
        {fieldToShow[0] === "garbage" && (
          <div style={paymentInformationDetails}>
            <div>Garbage</div>
            {/* <div style={amountStyle}>
              ksh {invoiceDataEditable.details.Garbage}
            </div> */}
            <input
              onFocus={handleInputFocus}
              type="number"
              style={amountStyle}
              value={invoiceDataEditable.details.Garbage}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceDataEditable,
                  details: {
                    ...invoiceDataEditable.details,
                    Garbage: e.target.value,
                  },
                })
              }
            />
          </div>
        )}
      </div>

      <button
                  style={continueButton}
                  onClick={() => onComplete(invoiceDataEditable)}
                >
                  Continue
                </button>
    </div>
  );
};

export default PartialPaymentPage;
